/**
 * Prices for new container type that can be added to the backend
 */
export interface NewContainerPrice {
  transactionPrice: string;
  storeLostCost: string;
  storeLostCostUpper: string;
  storeLostCostLower: string;
  overduePrice: string;
  creditsOnOverdueReturn: string;
}

/**
 * New container type that can be added to the backend
 */
export interface NewContainerType {
  name: string;
  isWhiteLabel: boolean;
  pricesByCurrency: { [key: string]: NewContainerPrice };
  groupId?: number | null;
  segment: string | null;
}

export const defaultNewContainerType: NewContainerType = {
  pricesByCurrency: {
    EUR: {
      transactionPrice: '0.2',
      storeLostCost: '1000',
      storeLostCostUpper: '650',
      storeLostCostLower: '350',
      overduePrice: '1000',
      creditsOnOverdueReturn: '500',
    },
  },
  name: 'New container type',
  isWhiteLabel: false,
  groupId: null,
  segment: null,
};
